import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface EntitySearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  className?: string;
  showIcon?: boolean;
}

export function EntitySearchInput({
  placeholder = "Поиск...",
  value,
  onChange,
  onFocus,
  onKeyDown,
  className,
  showIcon = false,
}: EntitySearchInputProps) {
  return (
    <div className={className}>
      {showIcon ? (
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4 z-10 pointer-events-none" />
      ) : null}
      <Input
        placeholder={placeholder}
        className={showIcon ? "pl-10 h-8 text-sm" : "h-8 text-sm"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}

